import { ToolsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"

export const toolsBaseKey = ["tools"] as const

export const toolsKey = (params: { include_retired: boolean }) =>
  [...toolsBaseKey, "list", params.include_retired] as const

export const toolKey = (toolId: string) =>
  [...toolsBaseKey, "detail", toolId] as const

export const toolsQuery = makeQuery({
  serviceCall: ToolsService.listTools,
  queryKey: toolsKey,
})

export const toolQuery = makeQuery({
  serviceCall: ToolsService.getTool,
  queryKey: (params: { tool_id: string }) => toolKey(params.tool_id),
})

export const useCreateToolMutation = makeAxiosMutation({
  serviceCall: ToolsService.createTool,
  invalidates: () => [toolsBaseKey],
})

export const useUpdateToolMutation = makeAxiosMutation({
  serviceCall: ToolsService.updateTool,
  invalidates: () => [toolsBaseKey],
})

export const useRetireToolMutation = makeAxiosMutation({
  serviceCall: ToolsService.retireTool,
  invalidates: () => [toolsBaseKey],
})

export const useRestoreToolMutation = makeAxiosMutation({
  serviceCall: ToolsService.restoreTool,
  invalidates: () => [toolsBaseKey],
})

export const useIssueToolMutation = makeAxiosMutation({
  serviceCall: ToolsService.issueTool,
  invalidates: () => [toolsBaseKey],
})

export const useReceiveToolMutation = makeAxiosMutation({
  serviceCall: ToolsService.receiveTool,
  invalidates: () => [toolsBaseKey],
})

export const useAddToolCalibrationMutation = makeAxiosMutation({
  serviceCall: ToolsService.addToolCalibration,
  invalidates: () => [toolsBaseKey],
})

export const useCompleteToolCalibrationMutation = makeAxiosMutation({
  serviceCall: ToolsService.completeToolCalibration,
  invalidates: () => [toolsBaseKey],
})

export const useAddToolDocumentMutation = makeAxiosMutation({
  serviceCall: ToolsService.addToolDocument,
  invalidates: () => [toolsBaseKey],
})

export const useRemoveToolDocumentMutation = makeAxiosMutation({
  serviceCall: ToolsService.removeToolDocument,
  invalidates: () => [toolsBaseKey],
})
